
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pdf-to-ppt",
      function () {
        return require("private-next-pages/pdf-to-ppt.js");
      }
    ]);
  